import { render, staticRenderFns } from "./LaundryQcConfirm.vue?vue&type=template&id=5848f8b4"
import script from "./LaundryQcConfirm.vue?vue&type=script&lang=js"
export * from "./LaundryQcConfirm.vue?vue&type=script&lang=js"
import style0 from "./LaundryQcConfirm.vue?vue&type=style&index=0&id=5848f8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports